// eslint-disable-next-line import/prefer-default-export
export const LANG_CACHE_KEY = 'sp_lang';
